import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './JobRangesTableEmptyState.scss';

const propTypes = {
  onAddModelClick: PropTypes.func,
  showAddModelOption: PropTypes.bool
};

const JobRangesTableEmptyState = props => {
  let addModelContent = null;
  if (props.showAddModelOption) {
    addModelContent = (
      <h3 className="jobRangeTable-empty__subheading">
        Begin building ranges for your jobs by&nbsp;
        <a onClick={props.onAddModelClick}>creating a model</a>
      </h3>
    );
  }

  return (
    <div className="jobRangeTable-empty__container">
      <img className="jobRangeTable-empty__icon" src="/view/static/mp/images/empty_models.svg" />
      <h1 className="jobRangeTable-empty__heading">No Models Available</h1>
      {addModelContent}
    </div>
  );
};

JobRangesTableEmptyState.propTypes = propTypes;

export default JobRangesTableEmptyState;
